<div
    class="sb-tab-group"
    [class.sb-tab-group-vertical]="orientation === Orientation.Vertical">
    <lib-tab-group-header
        [class.sb-tab-header-vertical]="orientation === Orientation.Vertical"
        [bodyComponent]="body"
        [stickyHeader]="stickyHeader"
        [selectedTab]="selectedTab"
        [enableFormProtection]="enableFormProtection"
        [isInNavigation]="isInNavigation"
        [hasBackground]="hasBackground"
        [type]="type"
        [size]="size"
        [orientation]="orientation"
        (selectedTabChange)="SelectedTabChangeEvent($event)"></lib-tab-group-header>

    <ng-content select="[addToUnderHeader]"></ng-content>

    <lib-tab-group-body #body>
        @for (tab of tabComponentQueryList; track $index) {
            <lib-tab
                [label]="tab.label"
                [icon]="tab.icon"
                [name]="tab.name"
                [lazyLoad]="tab.lazyLoad">
                <ng-template #tabContent>
                    <div class="mt-3">
                        <ng-container *ngTemplateOutlet="tab.tabContent"></ng-container>
                    </div>
                </ng-template>
            </lib-tab>
        }
    </lib-tab-group-body>
</div>
